import React from 'react';
import { IconButton, Stack, Typography, Box } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useDispatch, useSelector } from 'react-redux';
import { setSelected } from '@/features/table/dealsTableSlice';
import { BulkReassignButton } from '@/components/buttons/BulkActions/BulkReassignButton';
import { BulkChangeDealStageButton } from '@/components/buttons/BulkActions/BulkChangeDealStageButton';
import { getObjectType } from '@/utils/constants';
import { MAX_TABLE_SELECTION } from '@/components/table/data';

export const DealBulkActionsToolbar = ({ pipeline }) => {
	const dispatch = useDispatch();
	const { selected } = useSelector((state) => state.dealTable);
	const isDebtorSelection = pipeline === process.env.REACT_APP_PIPELINE_DEBTORS;
	const isClaimsSelection = pipeline === process.env.REACT_APP_PIPELINE_CLAIMS;
	const objectLabel = getObjectType(
		isDebtorSelection ? 'debtor' : isClaimsSelection ? 'ticket' : 'deal',
	);

	if (selected.length === 0) {
		return <></>;
	}

	const hasReachedMax = selected.length >= MAX_TABLE_SELECTION;

	return (
		<Stack
			direction='row'
			spacing={2}
			alignItems='center'
			sx={{ px: 1, py: 0.5 }}
		>
			<Box>
				<IconButton size='small' onClick={() => dispatch(setSelected([]))}>
					<ClearIcon />
				</IconButton>
				<Typography variant='task_updated' component='span'>
					{hasReachedMax
						? `Maximum of ${MAX_TABLE_SELECTION} ${objectLabel}s`
						: `${selected.length} ${objectLabel}${selected.length > 1 ? 's' : ''} selected`}
				</Typography>
			</Box>
			<BulkReassignButton pipeline={pipeline} />
			<BulkChangeDealStageButton pipeline={pipeline} />
		</Stack>
	);
};

DealBulkActionsToolbar.displayName = 'DealBulkActionsToolbar';
